import { useStore } from '~/store';
import type { RootState } from '~/store/slices';
import type { Clip } from '~/types/pipeline';

export function selectActiveClip(state: RootState): Clip | null {
  if (!state.clips.activeId) return null;
  return state.clips.list.find((clip) => clip.id === state.clips.activeId) ?? null;
}

export function useActiveClip(): Clip | null {
  return useStore(selectActiveClip);
}
